import { render, staticRenderFns } from "./BasicMaster.vue?vue&type=template&id=26434a61&"
import script from "./BasicMaster.vue?vue&type=script&lang=js&"
export * from "./BasicMaster.vue?vue&type=script&lang=js&"
import style0 from "./BasicMaster.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports